<template lang="pug">
.select-image(v-click-outside="closeList" :class="{ 'disabled': gameId == null }")
  .select-image-input.select-available(@click="toggleList" v-if="selectedCode===''")
    | {{ $t("message.select_option") }}
  .select-image-input.select-available(@click="toggleList" v-else)
    .select-image-option
      span {{ selectedCode }} - {{ selectedName }}
  .select-image-list.mb-2(:class="{'show': showList}")
    .select-image-option
      span {{ $t("message.select_option") }}
    .select-image-option.select-available(v-for="(option,i) in options" @click="checkOption($event, i)")
      span {{ option.template_code }} - {{ option.template_name }}
      i.fas.fa-fire.text-danger.float-right(v-if="highCount > 0 && option.total_selected == highCount")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  props: {
    value: {
      type: [Number,String],
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    disabledAll: {
      type: Boolean,
      default: true
    },
    gameId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    options: [],
    feedback: {
      success: true,
      status: ""
    },
    highCount: 0,
    showList: false,
    selectedCode: '',
    selectedName: ''
  }),
  mounted() {
    this.getMiniGameTemplateList();
  },
  methods: {
    closeList() {
      this.showList = false
    },
    toggleList(){
      if(this.value != null && this.value != '')
        this.showList = !this.showList
    },
    checkOption(e, i){
      if(this.options) {
        this.selectedCode = this.options[i].template_code
        this.selectedName = this.options[i].template_name
        this.toggleList()
        this.$emit("input", this.selectedCode);
      }
    },
    getMiniGameTemplateList() {
      if(this.gameId == null) return
      let url = config.getMiniGameTemplateListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        game_id: this.gameId,
        template_code: ""
      };
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.options = response.data.dt;
                var optionList = this.options
                this.presetDefault();
                this.findMaxValue(optionList);
                this.$emit("doneLoading", this.options);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.$emit("doneLoading");
              }
            }
          } catch (error) {
            this.$emit("doneLoading");
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          this.$emit("doneLoading");
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    presetDefault() {
      if(this.value != null && this.value != '') {
        const val = this.options.filter((a) => a.template_code == this.value)[0]
        if(val != null) {
          this.selectedCode = val.template_code
          this.selectedName = val.template_name
        }
      }
    },
    findMaxValue(optionList) {
      this.highCount = optionList.reduce((max, obj) => {
        return obj['total_selected'] > max && obj['template_code'] != 'TEMPLATE_DFLT' ? obj['total_selected'] : max;
      }, -Infinity);
    }
  }
};
</script>
